import React, { ErrorInfo } from "react"
import { ErrorFallbackUI } from "./ErrorFallbackUI"
import { ErrorBoundary } from "react-error-boundary"
import { captureException } from "../services/exception-logger"

type Props = {
  children: React.ReactNode
}

const logError = (error: Error, info: ErrorInfo) => {
  captureException(error, {
    type: "ui",
    category: "render",
    context: {
      errorSource: "ErrorBoundary - web",
      componentStack: info.componentStack,
    },
  })
}

export const ErrorBoundaryComponent = ({ children }: Props) => {
  return (
    <ErrorBoundary fallback={<ErrorFallbackUI />} onError={logError}>
      {children}
    </ErrorBoundary>
  )
}
